// Redux Service Worker module
// see https://github.com/erikras/ducks-modular-redux

import { reloadWithWhatsNewHint } from '../../services/whatsNewHint';

const SW_INIT       = 'kronos/sw/INIT';
const SW_HAS_UPDATE = 'kronos/sw/HAS_UPDATE';
const SW_DO_UPDATE  = 'kronos/sw/DO_UPDATE';

const initialState = {
    isInstalled: false,
    hasUpdate: false,
    registration: null
}

// Reducer
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SW_INIT:
            return {
                ...state,
                isInstalled: true,
                hasUpdate: false,
                registration: action.registration ?? state.registration
            };
        case SW_HAS_UPDATE:
            return {
                ...state,
                hasUpdate: true,
                registration: action.registration ?? state.registration
            };
        case SW_DO_UPDATE:
            return {
                ...state,
                hasUpdate: false
            };
        default:
            return state;
    }
};

export function swInstalled(registration) {
    return (dispatch) => {
        console.log('[sw] successfully installed');
        dispatch({ type: SW_INIT, registration});
    }
}

export function swHasUpdate(registration) {
    return (dispatch) => {
        console.log('[sw] an update is available');
        dispatch({ type: SW_HAS_UPDATE, registration});
    }
}

export function swUpdate() {
    return (dispatch, getState) => {
        console.log('[sw] updating app');
        const registration = getState()?.worker?.registration;

        if (registration?.waiting) {
            let isReloading = false;
            const fallbackTimer = setTimeout(() => {
                if (isReloading)
                    return;

                console.warn('[sw] controllerchange did not fire; forcing reload');
                isReloading = true;
                dispatch({ type: SW_DO_UPDATE });
                reloadWithWhatsNewHint();
            }, 5000);
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                clearTimeout(fallbackTimer);
                if (isReloading)
                    return;

                isReloading = true;
                dispatch({ type: SW_DO_UPDATE });
                reloadWithWhatsNewHint();
            });
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            return;
        }

        if (!window.caches?.keys) {
            dispatch({ type: SW_DO_UPDATE });
            reloadWithWhatsNewHint();
            return;
        }

        caches.keys().then(function(cacheNames) {
            return Promise.all(
                cacheNames.map(function(cacheName) {
                    console.log('[sw] deleting cache', cacheName);
                    return caches.delete(cacheName);
                })
            ).then(() => {
                dispatch({ type: SW_DO_UPDATE});
                reloadWithWhatsNewHint();
            });
        }).catch((err) => {
            console.error('[sw] cache cleanup failed', err);
            dispatch({ type: SW_DO_UPDATE });
            reloadWithWhatsNewHint();
        });
    }
}
